@if (open()) {
  <div
    class="bottom-sheet-overlay"
    uiAppendToBody
    uiSwipeSheetClose
    [swipeTransformSelector]="'.bottom-sheet'"
    [swipeZones]="'.header, .handle, .backdrop'"
    (uiSwipeTrigger)="closeEmit.emit()"
  >
    <div class="backdrop" (click)="closeEmit.emit()"></div>
    <div
      class="bottom-sheet"
      [class.stable-height]="stableHeight()"
      [style.height]="stableHeight() && sheetHeight() ? sheetHeight() : null"
    >
      <div class="handle" (click)="$event.stopPropagation()"></div>
      <div class="header">
        <h3 class="title">{{ (title() | titlecase) || '' }}</h3>
        <button class="close-btn" (click)="closeEmit.emit()" aria-label="Close">
          <span class="ui-icon-close"></span>
        </button>
      </div>
      <div class="content flex-col gap-16">
        <ng-content select="[sheet-content]"></ng-content>
      </div>
      <div class="separator"></div>
      <div class="w-100 sheet-actions">
        <ng-content select="[sheet-actions]"></ng-content>
      </div>
    </div>
  </div>
}
